import { measureModules } from "../measure";
import { ExtraType } from "./LedExtras";
import { OfferRequestItem } from "./OfferRequest";
export class OfferItem {
    constructor(shouldRotate = true, model, widthValue, projectionValue, extras, left = new Side(), right = new Side(), close = new Side(), far = new Side(), frameColor = MatColor.RAL9005, panelColor = MatColor.RAL1013, insulatedPanel = false, state = State.NOTHING, modelImage = "") {
        this.shouldRotate = shouldRotate;
        this.measuredModel = measureModules(shouldRotate, model, widthValue, projectionValue);
        this.widthValue = widthValue;
        this.projectionValue = projectionValue;
        this.extras = extras;
        this.left = left;
        this.right = right;
        this.close = close;
        this.far = far;
        this.frameColor = frameColor;
        this.panelColor = panelColor;
        this.insulatedPanel = insulatedPanel;
        this.state = state;
        this.modelImage = modelImage;
        // Not using for calculations
        this.wallNumber = 0;
        // Get the sides with walls, restrict max 3 size with wall
        if (this.left.wall === true) {
            this.left.extra = ExtraType.NONE;
            this.wallNumber++;
        }
        if (this.right.wall === true) {
            this.right.extra = ExtraType.NONE;
            this.wallNumber++;
        }
        if (this.close.wall === true) {
            this.close.extra = ExtraType.NONE;
            this.wallNumber++;
        }
        if (this.far.wall === true) {
            this.far.extra = ExtraType.NONE;
            this.wallNumber++;
        }
        if (this.wallNumber > 3) {
            this.close.wall = false;
        }
        this.freestanding = this.wallNumber === 0;
        // Logic to handle the walls in different models. PVC always needs a backside wall.
        if (this.measuredModel) {
            if (this.measuredModel.model.id === 4 && this.freestanding === false || this.measuredModel.model.id === 5 && this.freestanding === false) {
                this.far.wall = true;
            }
            // Switch to PVCfabric default color
            if (this.measuredModel.model.id > 3 && this.panelColor == MatColor.RAL1013)
                this.panelColor = MatColor.FS1210;
        }
    }
    copy({ shouldRotate = this.shouldRotate, model = this.measuredModel.model, widthValue = this.widthValue, projectionValue = this.projectionValue, extras = this.extras, left = this.left, right = this.right, close = this.close, far = this.far, frameColor = this.frameColor, panelColor = this.panelColor, insulatedPanel = this.insulatedPanel, state = this.state, modelImage = this.modelImage }) {
        return new OfferItem(shouldRotate, model, widthValue, projectionValue, extras, left, right, close, far, frameColor, panelColor, insulatedPanel, state, modelImage);
    }
    toOfferRequestItem() {
        return new OfferRequestItem(this.shouldRotate, this.measuredModel.model, this.widthValue, this.projectionValue, this.freestanding, this.extras, this.left, this.right, this.close, this.far, this.frameColor, this.panelColor, this.insulatedPanel, this.modelImage);
    }
    getExtrasAsArray() {
        let array = [];
        const obj = JSON.stringify(this);
        if (obj.includes("GLASS")) {
            array.push("Tolható üvegfal");
        }
        if (obj.includes("ZIPSCREEN")) {
            array.push("Zipscreen");
        }
        if (obj.includes("PARAPET")) {
            array.push("Parapet rendszer");
        }
        if (this.extras.spotLed || this.extras.linearLed || this.extras.panelLed || this.extras.perimeterLed || this.extras.threeAxisLed) {
            array.push("LED Világítás");
        }
        return array;
    }
}
export class Side {
    constructor(wall = false, extra = ExtraType.NONE) {
        this.wall = wall;
        this.extra = extra;
    }
}
export var MatColor;
(function (MatColor) {
    MatColor["RAL9010"] = "RAL9010";
    MatColor["RAL7039"] = "RAL7039";
    MatColor["RAL7040"] = "RAL7040";
    MatColor["RAL7016"] = "RAL7016";
    MatColor["RAL1013"] = "RAL1013";
    MatColor["RAL8017"] = "RAL8017";
    MatColor["RAL9005"] = "RAL9005";
    MatColor["SW3004"] = "SW3004";
    MatColor["PPMAT617"] = "PPMAT617";
    MatColor["RAL7666"] = "RAL7666";
    MatColor["PPMAT613"] = "PPMAT613";
    MatColor["PPMAT611"] = "PPMAT611";
    // Fabric colors
    MatColor["FS1210"] = "FS1210";
    MatColor["FS1230"] = "FS1230";
    MatColor["FS1260"] = "FS1260";
    MatColor["FS1480"] = "FS1480";
    /*	RAL7040F = "RAL7040F",
        RAL9005F = "RAL9005F",
        RAL3022 = "RAL3022",*/
    /*	RAL9010F = "RAL9010F",
        RAL7036 = "RAL7036",
        RAL8019 = "RAL8019",
        RAL1013F = "RAL1013F",
        RAL8025 = "RAL8025",
        RAL4001 = "RAL4001",
        RAL6203 = "RAL6203",
        RAL5008 = "RAL5008"*/
})(MatColor || (MatColor = {}));
export const metalColors = ["RAL9010",
    "RAL7039",
    "RAL7040",
    "RAL7016",
    "RAL1013",
    "RAL8017",
    "RAL9005",
    "SW3004",
    "PPMAT617",
    "RAL7666",
    "PPMAT613",
    "PPMAT611",
];
export const fabricColors = [
    "FS1210",
    "FS1230",
    "FS1260",
    "FS1480",
];
export const colorMap = {
    [MatColor.RAL9010]: '0xE5E5E5',
    [MatColor.RAL7039]: '0x8E8986',
    [MatColor.RAL7040]: '0xA3A7AB',
    [MatColor.RAL7016]: '0x68696E',
    [MatColor.RAL1013]: '0xD4D1C9',
    [MatColor.RAL8017]: '0x706666',
    [MatColor.RAL9005]: '0x3B3C41',
    [MatColor.SW3004]: '0xBFBEBD',
    [MatColor.PPMAT617]: '0x595759',
    [MatColor.RAL7666]: '0xDBDDDC',
    [MatColor.PPMAT613]: '0x49433F',
    [MatColor.PPMAT611]: '0x222527',
    // Fabric profiles
    [MatColor.FS1210]: '0xD4D1C9',
    [MatColor.FS1230]: '0xE5D7BA',
    [MatColor.FS1260]: '0x9E9995',
    [MatColor.FS1480]: '0x4E5F55',
    /*	[MatColor.RAL9010F]: '0xCFCBC9',
        [MatColor.RAL7036]: '0x838189',
        [MatColor.RAL8019]: '0x171616',
        [MatColor.RAL1013F]: '0xD4D2CD',
        [MatColor.RAL8025]: '0x5E423C',
        [MatColor.RAL4001]: '0x773F62',
        [MatColor.RAL6203]: '0x487293',
        [MatColor.RAL5008]: '0x111B2B',*/
};
export var WallSide;
(function (WallSide) {
    WallSide[WallSide["LEFT"] = 0] = "LEFT";
    WallSide[WallSide["RIGHT"] = 1] = "RIGHT";
    WallSide[WallSide["CLOSE"] = 2] = "CLOSE";
    WallSide[WallSide["FAR"] = 3] = "FAR";
})(WallSide || (WallSide = {}));
export var State;
(function (State) {
    State[State["NOTHING"] = 0] = "NOTHING";
    State[State["WALLSELECTING"] = 1] = "WALLSELECTING";
    State[State["EXTRASELECTING"] = 2] = "EXTRASELECTING";
    State[State["COLORSELECTING"] = 3] = "COLORSELECTING";
    State[State["LIGHTSELECTING"] = 4] = "LIGHTSELECTING";
})(State || (State = {}));
